var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410127315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 17C13.6683 17 17.25 13.4183 17.25 9C17.25 4.58172 13.6683 1 9.25 1C4.83172 1 1.25 4.58172 1.25 9C1.25 13.4183 4.83172 17 9.25 17Z",
    fill: "#006B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24943 4.31776L4.99877 8.56843H7.58917V13.682H10.9097L10.9097 8.56843H13.5001L9.24943 4.31776Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.febb7adcaafd8e1d12186a9406a47f33.svg";
export { ForwardRef as ReactComponent };